import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { fmtDate } from "../lib/api";
import { StatusChip } from "./kit";
import { useBlobUrl } from "./Lesson";

function Photo({ id, alt }) {
  const url = useBlobUrl(id);
  return url ? <img src={url} alt={alt} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" />
    : <div className="h-full w-full animate-pulse bg-muted" />;
}

export function CourseCover({ fileId, title, className = "" }) {
  return (
    <div className={`relative overflow-hidden bg-[color:var(--ink)] ${className}`} data-testid={fileId ? "course-cover-photo" : "course-cover-branded"}>
      {fileId ? <Photo id={fileId} alt={title} /> : (
        <div className="grain flex h-full w-full items-end justify-between gap-4 p-5">
          <span className="font-lesson-serif text-2xl leading-tight !text-white/90 line-clamp-2">{title}</span>
          <img src="/brand/dcbc_mark_red.png" alt="" className="h-12 w-auto shrink-0 opacity-90" />
        </div>)}
    </div>
  );
}

export function CourseCard({ a }) {
  const pct = a.sections_total ? Math.round((a.sections_done.length / a.sections_total) * 100) : 0;
  const started = a.sections_done.length > 0 || a.last_section_id;
  return (
    <Link to={`/training/${a.id}`} data-testid={`course-card-${a.id}`}
      className="group flex min-w-0 flex-col overflow-hidden rounded-2xl border bg-white transition-[border-color,box-shadow] hover:border-[color:var(--ink)] hover:shadow-md">
      <CourseCover fileId={a.cover_file_id} title={a.course_title} className="aspect-[16/7]" />
      <div className="flex flex-1 flex-col gap-3 p-4">
        <div className="flex items-start justify-between gap-3">
          <p className="min-w-0 font-semibold leading-snug">{a.course_title} <span className="text-xs font-normal text-muted-foreground">v{a.version}</span></p>
          <StatusChip status={a.state} />
        </div>
        {a.course_description && <p className="text-sm text-muted-foreground line-clamp-2">{a.course_description}</p>}
        <div className="mt-auto space-y-2">
          {a.state !== "completed" && <div className="h-1.5 w-full rounded-full bg-muted" aria-label={`${pct}% of sections done`}><div className="h-1.5 rounded-full bg-[color:var(--hops)]" style={{ width: `${pct}%` }} /></div>}
          <div className="flex items-center justify-between text-sm text-muted-foreground">
            <span>{a.state === "completed" ? `Completed ${fmtDate(a.completed_at)}` : a.due_date ? `Due ${fmtDate(a.due_date)}` : "No due date set"}</span>
            <span className="inline-flex items-center gap-1 font-semibold text-[color:var(--ink)]">{a.state === "completed" ? "Review" : started ? "Resume" : "Start"} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" /></span>
          </div>
        </div>
      </div>
    </Link>
  );
}
